import OptimizedImage from "@/components/OptimizedImage";
import React from "react";
import { User } from "lucide-react";
import { useArtistUsp } from "@/api/hooks/useArtistUsp";
import { useArtistDisplayName, useArtistProfilePic } from "@/api/hooks/useArtistDisplayName";
import { SparkleMaskedName } from "@/components/ui/SparkleMaskedName";
import MaskProfessionalNameInText from "../../utils/MaskProfessionalNameInText";

const ArtistEconomyHero = () => {
  const { uspText, hasUsp } = useArtistUsp();
  const displayName = useArtistDisplayName();
  const profilePic = useArtistProfilePic();

  return (
    <div className="h-[85vh] w-screen relative overflow-hidden">
      {profilePic ? (
        <OptimizedImage
          src={profilePic}
          alt={displayName}
          loading="lazy"
          unoptimized={true}
          fetchPriority="high"
          fill={true}
          className="object-cover w-full h-full max-md:mt-16"
        />
      ) : (
        <div className="absolute inset-0 bg-[#2C2C2E] flex items-center justify-center">
          <User className="h-[40%] w-[40%] text-[#8E8E93] opacity-50" />
        </div>
      )}
      <div className="w-[150%] h-full absolute top-0 -right-20 bg-black/40 flex items-end z-10">
        <div className="w-full h-60 bg-black blur-2xl -mb-20"></div>
      </div>
      <div className="absolute bottom-8 max-sm:bottom-0 right-10 z-10 space-y-4 p-10 max-sm:p-0 rounded-3xl max-sm:px-4">
        <h1 className="text-4xl max-sm:text-2xl font-bold">
          <SparkleMaskedName name={displayName} />
        </h1>
        <p
          className={`max-w-md max-sm:text-sm ${!hasUsp ? "opacity-90 italic" : ""}`}
        >
          <MaskProfessionalNameInText value={uspText} />
        </p>
        <button className="bg-gradient-to-b from-[#EC2179] to-[#F16B2E] max-sm:text-base px-8 py-3 text-lg rounded-xl">
          SEE PRICE & BOOK
        </button>
      </div>
    </div>
  );
};

export default ArtistEconomyHero;
